// Re-queried fresh at call time (not a captured node reference) since the
// trigger element can be remounted with a new DOM node while a side sheet is
// open (e.g. the notification icon swaps between badge/no-badge variants).
export const focusHeaderIcon = (testId: string) => {
  setTimeout(() => {
    const el = document.querySelector(`[data-testid="${testId}"]`) as HTMLElement | null;
    el?.focus?.();
  }, 50);
};
